
import axios from "axios";
import { apis } from "../constants/apis";
import httpService from "./httpService";
import { LocalStorageKey } from "../constants/localStorageKeys";

export async function addImgIntoCart(payload: any)
{
  // return httpService.post(`${apis.cart.addImage}`, payload);

  const staticConfigs = JSON.parse(localStorage.getItem(LocalStorageKey.STATIC_CONFIG) ?? '');
  const baseUrl = staticConfigs?.REACT_APP_API_BASE_URL
  return axios.post(`${baseUrl}${apis.cart.addImage}`, payload);
}

export async function delImgIntoCart(payload: any)
{
  // return httpService.post(`${apis.cart.delImage}`, payload);

  const staticConfigs = JSON.parse(localStorage.getItem(LocalStorageKey.STATIC_CONFIG) ?? '');
  const baseUrl = staticConfigs?.REACT_APP_API_BASE_URL

  console.log(payload, 'payload in delImgIntoCart')
  return axios.delete(`${baseUrl}/vmrs/api/v1/carts/remove/items`, { data: payload });
}

export async function getImgs(payload: any)
{
  // return httpService.get(`${apis.cart.getImage}`, payload);

  const staticConfigs = JSON.parse(localStorage.getItem(LocalStorageKey.STATIC_CONFIG) ?? '');
  const baseUrl = staticConfigs?.REACT_APP_API_BASE_URL
  return axios.get(`${baseUrl}${apis.cart.getImage}`, payload);
}

export async function getProductBundleByItemType(payload: any)
{
  return httpService.get(
    `${apis.cart.getProductBunbleByItemType}/${payload?.itemType}`
  );
}
